/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

@import '@spectrum/spectrum-variables/stylus/spectrum-light.styl'

:local(.root)
  margin 0 40px
  overflow hidden

:local(.header)
  padding-left 0
  padding-right 0

:local(.flex-table)
  flex 1

:local(.sessions-table)
  height 100%
  overflow hidden
  padding 0
  width 100%

:local(.createdCell)
  align-items center
  display flex
  justify-content space-between
  width 250px

  :global(.notice)
    align-items center
    display flex

    svg
      margin-right 8px

:local(.actionbar)
  width calc(100% - 64px)
  position absolute
  bottom 0
  left 32px
  :global(.spectrum-ActionBar)
    padding: 0
